<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        :data-url="
          selectedUrl
            ? `/details/responsible/${inputs.id}`
            : '/details/responsible'
        "
      >
        <div class="row">
          <div
            class="col-md-6"
            v-if="
              ['OEYC', 'OENY', 'OICC'].includes(this.activity) &&
              ['PAFIR'].includes(this.type)
            "
          >
            <div class="form-group">
              <label>Campo de Ensayo / Calibración</label>
              <app-input
                type="text"
                v-model="inputs.field"
                placeholder="Ingrese el campo de ensayo / calibración"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Nombre y Apellidos Completos</label>
              <app-input
                type="text"
                v-model="inputs.name"
                placeholder="Ingrese los nombres y apellidos"
                :required="true"
              />
            </div>
          </div>

          <div
            class="col-md-6"
            v-if="
              [
                'RFA1',
                'RFA2',
                'DTL',
                'RL',
                'ARTN',
                'RTOI',
                'PDEA',
                'RFOC',
              ].includes(this.type) ||
              (['OCLN'].includes(this.activity) &&
                ['PAFIR'].includes(this.type)) ||
              (['OCLN'].includes(this.activity) && ['RSGC'].includes(this.type))
            "
          >
            <div class="form-group">
              <label>Tipo de Identificación</label>
              <app-input
                type="select"
                v-model="inputs.taxid_type"
                v-on:change="onChangeTaxid"
                :required="true"
                :list="taxidTypeLists"
              />
            </div>
          </div>

          <div
            class="col-md-6"
            v-if="
              [
                'RFA1',
                'RFA2',
                'DTL',
                'RL',
                'ARTN',
                'RTOI',
                'PDEA',
                'RFOC',
              ].includes(this.type) ||
              (['OCLN'].includes(this.activity) &&
                ['PAFIR'].includes(this.type)) ||
              (['OCLN'].includes(this.activity) && ['RSGC'].includes(this.type))
            "
          >
            <div class="form-group">
              <label>Número de Cédula</label>
              <app-input
                type="text"
                v-model="inputs.taxid"
                placeholder="Ingrese el número de cédula"
                :required="true"
                @keyup="onChangeTaxid"
              />
            </div>
          </div>

          <div
            class="col-md-6"
            v-if="
              ['DTL', 'RSGC1', 'DTPEA', 'RSGC', 'CTCP', 'RTOI'].includes(
                this.type
              )
            "
          >
            <div class="form-group">
              <label>Titular (1) Sustituto (2)</label>
              <app-input
                type="text"
                v-model="inputs.head"
                placeholder="Ingrese el titular/sustituto"
                :required="true"
              />
            </div>
          </div>

          <div
            class="col-md-6"
            v-if="
              ['OEYC', 'OENY'].includes(this.activity) &&
              ['RFA1', 'RFA2'].includes(this.type)
            "
          >
            <div class="form-group">
              <label>Cargo</label>
              <app-input
                type="text"
                v-model="inputs.responsable"
                placeholder="Ingrese el cargo"
                :required="true"
              />
            </div>
          </div>

          <div
            class="col-md-6"
            v-if="
              ['DTL', 'RSGC', 'DTPEA', 'CTCP', 'PDEA', 'RFOC'].includes(
                this.type
              ) ||
              (['OICC'].includes(this.activity) &&
                ['RFA1', 'RFA2'].includes(this.type)) ||
              (['OCPE'].includes(this.activity) && ['RL'].includes(this.type))
            "
          >
            <div class="form-group">
              <label>Cargo</label>
              <app-input
                type="text"
                v-model="inputs.position"
                placeholder="Ingrese el cargo"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="['PAFIR'].includes(this.type)">
            <div class="form-group">
              <label>Calificación</label>
              <app-input
                type="text"
                v-model="inputs.qualification"
                placeholder="Ingrese la calificación"
                :required="true"
              />
            </div>
          </div>

          <div
            class="col-md-6"
            v-if="
              ['OCLN'].includes(this.activity) && ['PAFIR'].includes(this.type)
            "
          >
            <div class="form-group">
              <label>Campo de Análisis</label>
              <app-input
                type="text"
                v-model="inputs.field"
                placeholder="Ingrese el campo de análisis"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="['CTCP'].includes(this.type)">
            <div class="form-group">
              <label>Programa</label>
              <app-input
                type="text"
                v-model="inputs.program"
                placeholder="Ingrese el programa"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="['RTOI'].includes(this.type)">
            <div class="form-group">
              <label>Alcance Bajo su Responsabilidad</label>
              <app-input
                type="text"
                v-model="inputs.scope"
                placeholder="Ingrese el alcance bajo su responsabilidad"
                :required="true"
              />
            </div>
          </div>

          <div
            class="col-md-6"
            v-if="
              ['ARTN'].includes(this.type) ||
              (['OINSP'].includes(this.activity) && ['RL'].includes(this.type))
            "
          >
            <div class="form-group">
              <label>Teléfono</label>
              <app-input
                type="tel-input"
                v-model="inputs.phone"
                placeholder="Ingrese el teléfono"
                :required="true"
              />
            </div>
          </div>

          <div
            class="col-md-6"
            v-if="
              [
                'RFA1',
                'RFA2',
                'DTL',
                'RSGC',
                'DTPEA',
                'CTCP',
                'RL',
                'ARTN',
                'RTOI',
                'PDEA',
                'RFOC',
              ].includes(this.type)
            "
          >
            <div class="form-group">
              <label>E-mail</label>
              <app-input
                type="email"
                v-model="inputs.email"
                placeholder="Ingrese el e-mail"
                :required="true"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    type: String,
    activity: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      modalId: "add-edit-modal",
      disabledSubmit: false,
      taxid: null,
      delayTimer: null,
      taxidTypeLists: [
        { id: "", value: "Seleccione" },
        { id: "ci", value: "Cédula de Identidad" },
        { id: "other", value: "Otros" },
      ],
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      if (this.inputs.taxid_type == "ci") {
        if (this.taxid == null) return;
        if (!this.taxid) {
          this.$toastr.e("La CI no es valida");
          return;
        }
      }
      this.inputs.acc_app_id = this.$store.state.accreditation.id;
      this.inputs.type = this.type;
      this.disabledSubmit = true;
      this.save(this.inputs);
    },

    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    afterSuccess(response) {
      // this.$toastr.s(response.data.message);
      this.$toastr.s(this.$t("created_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.preloader = false;
    },

    onChangeTaxid() {
      if (this.inputs.taxid && this.inputs.taxid_type == "ci") {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(this.validateTaxid, 1000);
      }
    },
    validateTaxid() {
      this.preloader = true;
      let url = `/register/users/validate/${this.inputs.taxid}/ci`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            if (!response.data.validate) {
              this.$toastr.e(response.data.message);
            }
            this.taxid = response.data.validate;
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
